<template>
  <div class="q-pa-md">
    <div class="row justify-center">
      <div class="col-12 col-sm-8 col-md-6">
        <q-banner class="rounded-borders text-center bg-green-2 text-green-10">
          {{ $t('notice.transfer.rate_was_set') }}
        </q-banner>
      </div>
    </div>
    <div
      v-if="rate.rate_val < 5"
      class="q-mt-md text-center"
    >
      <p class="fs-14 q-mb-sm">{{ $t('label.rating_change') }}</p>
      <q-rating
        :value="rate.rate_val"
        class="external-rate"
        size="24px"
        color="yellow"
        icon="star_border"
        icon-selected="star"
        no-dimming
        no-reset
        @input="changeRateVal"
      />
    </div>
    <q-dialog
      :value="true"
      persistent
    >
      <q-card class="rate-body">
        <q-card-section class="text-right q-pb-none">
          <q-btn
            v-close-popup
            icon="close"
            flat
            round
            dense
          />
        </q-card-section>
        <q-card-section class="q-pt-none text-center">
          <img
            src="common/logo.svg"
            alt="main_logo"
            width="168"
          >
          <div class="q-my-md text-uppercase text-bold fs-18">
            {{ $t('label.passenger_feedback') }}
          </div>
          <q-rating
            class="external-rate q-mb-md"
            :value="rate.rate_val"
            size="24px"
            color="yellow"
            icon="star_border"
            icon-selected="star"
            no-dimming
            no-reset
            :readonly="rate.rate_val === 5"
            @input="changeRateVal"
          />
          <template v-if="canShare">
            <p>{{ $t('label.share_experience') }}</p>
            <q-btn
              type="a"
              :href="socialLink"
              icon="thumb_up"
              no-caps
              unelevated
              color="blue-9"
              :label="$t('label.like')"
            />
          </template>
          <div v-else-if="rate.rate_val < 5">
            {{ $t('label.rating_change') }}
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
export default {
  name: 'Rate',
  props: {
    rate: {
      type: Object,
      required: true,
    },
  },
  data() {
    const { transfer_id, rate_key } = this.rate;
    return {
      socialLink: `/transfers/external_rate/${transfer_id}${rate_key ? `?rate_key=${rate_key}` : ''}`,
    };
  },
  computed: {
    canShare() {
      return this.rate.rate_val === 5 && this.rate.external_rate === 'false';
    },
  },
  methods: {
    changeRateVal(val) {
      window.location = `/client/rate/${this.rate.transfer_id}?rate_val=${val}&rate_key=${this.rate.rate_key}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.rate-body {
  width: 450px;
}
.external-rate ::v-deep {
  .q-rating__icon + .q-rating__icon {
    margin-left: 8px;
  }
  i {
    text-shadow: none !important;
  }
}
</style>
